@if (reservation$ | async; as res) {
  <div ngbDropdown
       class="ps-3">
    <div ngbDropdownToggle
         role="button">
      Guest: <b>{{ res.PrimaryGuest?.FirstName }} {{ res.PrimaryGuest?.LastName }}</b>
    </div>
    <div ngbDropdownMenu>
      <era-guest-info></era-guest-info>
    </div>
  </div>
}